import { toastr } from 'react-redux-toastr';
import QueryString from 'query-string';
import { push } from 'react-router-redux';
import {
  FLAG_BILLING_ACTIVITY,
  GET_BILLING,
  CLEAR_BILLING,
  FLAG_GETTING_BILLINGS,
  CLEAR_BILLINGS,
  GET_BILLINGS,
  FLAG_GETTING_BILLING_REPORT,
  CLEAR_BILLING_REPORT,
  GET_BILLING_REPORT,
  FLAG_GETTING_BILLING_REPORT_DETAILS,
  CLEAR_BILLING_REPORT_DETAILS,
  GET_BILLING_REPORT_DETAILS,
  GET_BILLING_REPORT_DETAIL,
  FLAG_BILLING_REPORT_DETAIL_ACTIVITY,
  CLEAR_BILLING_REPORT_DETAIL,
  FLAG_GETTING_BILLINGS_RETENTION,
  CLEAR_BILLINGS_RETENTION,
  GET_BILLINGS_RETENTION,
  GET_BILL_RECONCILIATION,
  FLAG_GETTING_BILL_RECONCILIATION,
  CLEAR_BILL_RECONCILIATION,
} from '../types/accounting';
import {
  BILLING_ENDPOINT,
  BILLING_ENDPOINT_V2,
  BILLING_REVERSION_ENDPOINT,
  FACTURADOR_CDR_ENDPOINT,
  FACTURADOR_PDF_ENDPOINT,
  FACTURADOR_XML_ENDPOINT,
  generateContingencyGrtBillingByItineraryEndpoint,
  generateDisabledBillingsByItinerayIdEndpoint,
  generateGrtBillingReportByItineraryEndpoint,
  MANUAL_GRR_ENDPOINT,
  MANUAL_GRR_ENDPOINT_V2,
} from '../../config/endpoints';
import {
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
  PDF_GET_CONFIG,
  XML_GET_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { BILLING_PATH, BILLING_REPORT_DETAIL_PATH } from '../../config/paths';

const flagGettingBillings = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BILLINGS,
    payload: flag,
  });

const clearBillings = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLINGS,
  });

const flagBillingActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BILLING_ACTIVITY,
    payload: flag,
  });

const clearBilling = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLING,
  });

const clearBillingReportDetail = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLING_REPORT_DETAIL,
  });

const flagGettingBillingReport = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BILLING_REPORT,
    payload: flag,
  });

const flagBillingReportDetailActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BILLING_REPORT_DETAIL_ACTIVITY,
    payload: flag,
  });

const clearBillingReport = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLING_REPORT,
  });

const flagGettingBillingReportDetails = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BILLING_REPORT_DETAILS,
    payload: flag,
  });

const clearBillingReportDetails = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLING_REPORT_DETAILS,
  });

const getBillingReportDetails =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBillingReportDetails(true));

      const url = `${MANUAL_GRR_ENDPOINT}/report-detail?${QueryString.stringify(
        tableFilters,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({ type: GET_BILLING_REPORT_DETAILS, payload: response });
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillingReportDetails(false));
    }
    return null;
  };

const getBillings =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBillings(true));

      const url = `${MANUAL_GRR_ENDPOINT}?${QueryString.stringify(
        tableFilters,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({ type: GET_BILLINGS, payload: response });
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillings(false));
    }
    return null;
  };

const getBillingsV2 =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBillings(true));

      const url = `${MANUAL_GRR_ENDPOINT_V2}?${QueryString.stringify(
        tableFilters,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({ type: GET_BILLINGS, payload: response });
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillings(false));
    }
    return null;
  };

const obtainBillingReport =
  async ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const url = generateGrtBillingReportByItineraryEndpoint(itineraryId);
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
    return null;
  };

const obtainBilling = async ({ billingId }) => {
  const url = `${BILLING_ENDPOINT}/${billingId}`;
  const promise = await fetch(url, DEFAULT_GET_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const obtainBillingReportDetail = async ({ billingReporDetailId }) => {
  const url = `${MANUAL_GRR_ENDPOINT}/report-detail/${billingReporDetailId}`;
  const promise = await fetch(url, DEFAULT_GET_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const obtainBillingReportSummary = async (dateFrom, dateTo) => {
  const url = `${MANUAL_GRR_ENDPOINT}/report-summary?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const promise = await fetch(url, DEFAULT_GET_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const obtainBillingReportSummarybyDocument = async (dateFrom, dateTo) => {
  const url = `${MANUAL_GRR_ENDPOINT}/report-summary-by-document?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const promise = await fetch(url, DEFAULT_GET_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const obtainBillingReportDetailJob = async (dateFrom, dateTo) => {
  const url = `${MANUAL_GRR_ENDPOINT}/report-detail/job?dateFrom=${dateFrom}&dateTo=${dateTo}`;
  const promise = await fetch(url, DEFAULT_POST_CONFIG);
  await isErrorResponse(promise);
  const response = await promise.json();
  return response;
};

const getBilling =
  async ({ billingId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const response = await obtainBilling({ billingId });
      dispatch({
        type: GET_BILLING,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
  };

const getBillingReportDetail =
  async ({ billingReporDetailId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingReportDetailActivity(true));

      const response = await obtainBillingReportDetail({
        billingReporDetailId,
      });
      dispatch({
        type: GET_BILLING_REPORT_DETAIL,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingReportDetailActivity(false));
    }
  };

const postBillingReportDetail =
  async (dateTo, dateFrom) => async (dispatch) => {
    try {
      dispatch(flagBillingReportDetailActivity(true));

      const response = await obtainBillingReportDetailJob(dateTo, dateFrom);

      dispatch(push(`${BILLING_REPORT_DETAIL_PATH}/${response.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingReportDetailActivity(false));
    }
  };

const putBilling =
  async (
    billingId,
    {
      processType,
      documentSeries,
      refDocumentSeries,
      documentCode,
      refDocumentCode,
      itineraryId,
      json,
      extraFields,
      jsonRequest,
      response,
      status,
      createDate,
      retry,
      active,
      cdrAttemps,
    },
    secondVersion = false,
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const payload = {
        processType,
        documentSeries,
        refDocumentSeries,
        documentCode,
        refDocumentCode,
        itineraryId,
        json,
        extraFields,
        jsonRequest,
        response,
        status,
        createDate,
        retry,
        active,
        cdrAttemps,
        id: billingId,
      };

      let url = null;
      if (secondVersion) {
        url = `${BILLING_ENDPOINT_V2}/${billingId}`;
      } else {
        url = `${BILLING_ENDPOINT}/${billingId}`;
      }
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      const billing = await promise.json();

      dispatch(push(`${BILLING_PATH}/${billing.id}`));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
  };

const putDisabledBillingsByItinerayId =
  async ({ itineraryId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const url = generateDisabledBillingsByItinerayIdEndpoint(itineraryId);

      const promise = await fetch(url, DEFAULT_PUT_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const billing = await promise.json();

      return toastr.info('Información', billing.message);
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
    return null;
  };

const getContingencyBillingsByItinerayIdAndSourceLocation =
  async ({ query }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const url = `${generateContingencyGrtBillingByItineraryEndpoint()}?${QueryString.stringify(
        query,
      )}`;

      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const billing = await promise.json();

      return billing;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
    return null;
  };

const obtainBillingDeliveryContingecyGuide =
  async ({ billingId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const url = `${BILLING_ENDPOINT}/contingency-delivery/${billingId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise);
      const response = await promise.json();
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBillingActivity(false));
    }
    return null;
  };

const getPdfBillProcess = async (ticket) => async (dispatch) => {
  try {
    dispatch(flagBillingActivity(true));
    const url = `${FACTURADOR_PDF_ENDPOINT}${ticket}`;
    const response = await fetch(url, {
      ...PDF_GET_CONFIG,
    });
    await isErrorResponse(response, null, dispatch);

    const blob = await response.blob();
    const urlPdf = window.URL.createObjectURL(blob);
    window.open(urlPdf, '_blank');
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBillingActivity(false));
  }
};

const getCdrBillProcess = (ticket) => async (dispatch) => {
  try {
    dispatch(flagBillingActivity(true));
    const url = `${FACTURADOR_CDR_ENDPOINT}${ticket}`;
    const response = await fetch(url, {
      ...XML_GET_CONFIG,
    });

    await isErrorResponse(response, null, dispatch);

    const blob = await response.blob();
    const urlCdr = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = urlCdr;
    a.download = `cdr_${ticket}.xml`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // Liberar URL del blob
    window.URL.revokeObjectURL(urlCdr);
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBillingActivity(false));
  }
};

const getXmlBillProcess = (ticket) => async (dispatch) => {
  try {
    dispatch(flagBillingActivity(true));
    const url = `${FACTURADOR_XML_ENDPOINT}${ticket}`;
    const response = await fetch(url, {
      ...XML_GET_CONFIG,
    });

    await isErrorResponse(response, null, dispatch);

    const blob = await response.blob();
    const urlXml = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = urlXml;
    a.download = `xml_${ticket}.xml`;
    document.body.appendChild(a);
    a.click();
    a.remove();

    // Liberar URL del blob
    window.URL.revokeObjectURL(urlXml);
  } catch (error) {
    toastr.error('Error', error.message);
  } finally {
    dispatch(flagBillingActivity(false));
  }
};

const getBillingReportSummary =
  async (dateTo, dateFrom) => async (dispatch) => {
    try {
      dispatch(flagGettingBillingReport(true));

      const response = await obtainBillingReportSummary(dateTo, dateFrom);
      dispatch({
        type: GET_BILLING_REPORT,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillingReport(false));
    }
  };

const getBillingReportSummaryByDocument =
  async (dateTo, dateFrom) => async (dispatch) => {
    try {
      dispatch(flagGettingBillingReport(true));

      const response = await obtainBillingReportSummarybyDocument(
        dateTo,
        dateFrom,
      );
      dispatch({
        type: GET_BILLING_REPORT,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillingReport(false));
    }
  };

const flagGettingBillingRetention = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BILLINGS_RETENTION,
    payload: flag,
  });

const clearBillingRetention = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILLINGS_RETENTION,
  });

const getBillingRetention =
  async (tableFilters = null) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingBillingRetention(true));

      const url = `${BILLING_ENDPOINT}/retention?${QueryString.stringify(
        tableFilters,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({ type: GET_BILLINGS_RETENTION, payload: response });
      return response;
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingBillingRetention(false));
    }
    return null;
  };

const postBillingReversion =
  async ({ refDocumentSeries, refDocumentCode, reasonDescription }) =>
  async (dispatch) => {
    try {
      dispatch(flagBillingActivity(true));

      const payload = {
        refDocumentSeries,
        refDocumentCode,
        reasonDescription,
      };

      const url = BILLING_REVERSION_ENDPOINT;
      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });

      await isErrorResponse(promise, null, dispatch);
      toastr.success('Reversión creada correctamente');

      return true;
    } catch ({ message }) {
      toastr.error('Error', message);
      return false;
    } finally {
      dispatch(flagBillingActivity(false));
    }
  };

const flagGettingBillReconciliation = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_BILL_RECONCILIATION,
    payload: flag,
  });

const clearBillReconciliation = () => (dispatch) =>
  dispatch({
    type: CLEAR_BILL_RECONCILIATION,
  });

const getBillReconciliation = (startDate, endDate) => async (dispatch) => {
  try {
    dispatch(flagGettingBillReconciliation(true));

    const url = `${MANUAL_GRR_ENDPOINT}/reconciliation?${QueryString.stringify({
      startDate,
      endDate,
    })}`;

    const promise = await fetch(url, DEFAULT_GET_CONFIG);

    await isErrorResponse(promise, null, dispatch);

    const response = await promise.json();

    dispatch({
      type: GET_BILL_RECONCILIATION,
      payload: response,
    });

    return response;
  } catch ({ message }) {
    toastr.error('Error', message);
    return null;
  } finally {
    dispatch(flagGettingBillReconciliation(false));
  }
};

export {
  flagGettingBillings,
  clearBillings,
  getBillings,
  flagBillingActivity,
  clearBillingReport,
  flagGettingBillingReport,
  getBilling,
  getBillingsV2,
  clearBilling,
  clearBillingReportDetails,
  clearBillingReportDetail,
  getBillingReportDetails,
  getBillingReportDetail,
  putBilling,
  obtainBillingReport,
  putDisabledBillingsByItinerayId,
  getContingencyBillingsByItinerayIdAndSourceLocation,
  obtainBillingDeliveryContingecyGuide,
  getPdfBillProcess,
  getCdrBillProcess,
  getXmlBillProcess,
  getBillingReportSummary,
  getBillingReportSummaryByDocument,
  postBillingReportDetail,
  clearBillingRetention,
  getBillingRetention,
  postBillingReversion,
  getBillReconciliation,
  clearBillReconciliation,
};
